export const SOCKET_ROOM = {
    DEFAULT: 'planner',
    PLANNER: 'planner',
    AUTH: 'authentication',
    AUTHENTICATED: 'authenticated',
    PRESENCE: 'presence',
    CHAT: 'chat'
}
